
import { Vue, Component } from 'vue-property-decorator'
import SearchWidget from '@/components/dashboard/SearchWidget.vue'
import InfoHover from '@/components/dashboard/InfoHover.vue'
import PageHeader from '@/components/base/PageHeader.vue'
import User from '@/types/user'

@Component({
  components: { PageHeader, InfoHover, SearchWidget }
})

export default class Dashboard extends Vue {
  get authUser () : User {
    return this.$store.getters['authStore/authUser']
  }
}
